import widget from './widget';
import settings from './settings';

export default {
  widget,
  settings,
  name: 'Distributor production queue',
  description: 'Displays a production queue for distributors'
};



// WEBPACK FOOTER //
// ./app/widgets/ProductionQueueDistributor/index.js